import { render, staticRenderFns } from "./IconVerlichtingVinkje.vue?vue&type=template&id=09d97f52"
import script from "./IconVerlichtingVinkje.vue?vue&type=script&lang=ts"
export * from "./IconVerlichtingVinkje.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports